/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Feature Unit
 * @export
 * @interface FeatureUnit
 */
export interface FeatureUnit {
    /**
     * Symbol of the feature unit
     * @type {string}
     * @memberof FeatureUnit
     */
    symbol?: string;
    /**
     * Name of the feature unit
     * @type {string}
     * @memberof FeatureUnit
     */
    name?: string;
    /**
     * Type of the feature unit
     * @type {string}
     * @memberof FeatureUnit
     */
    unitType?: string;
}

/**
 * Check if a given object implements the FeatureUnit interface.
 */
export function instanceOfFeatureUnit(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeatureUnitFromJSON(json: any): FeatureUnit {
    return FeatureUnitFromJSONTyped(json, false);
}

export function FeatureUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'unitType': !exists(json, 'unitType') ? undefined : json['unitType'],
    };
}

export function FeatureUnitToJSON(value?: FeatureUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbol': value.symbol,
        'name': value.name,
        'unitType': value.unitType,
    };
}

